import { render, staticRenderFns } from "./BuyDirect.vue?vue&type=template&id=199a82ea&scoped=true"
import script from "./BuyDirect.vue?vue&type=script&lang=js"
export * from "./BuyDirect.vue?vue&type=script&lang=js"
import style0 from "./BuyDirect.vue?vue&type=style&index=0&id=199a82ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199a82ea",
  null
  
)

export default component.exports